import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface ILeaderProfit {
    all_time: number
    monthly: number
}

// admin/copy/leaders 응답 행(copyLeaderRow).
export interface ILeader {
    id: string
    user_id: string
    copy_lead_name?: string
    exchange?: string
    copier?: number
    max_copier?: number
    mdd?: number
    risk?: number
    tpd?: number
    win?: number
    loss?: number
    allow_copy?: boolean
    created_at?: number // unix 초
    user_name?: string
    user_thumbnail?: string
    all_time_profit?: number
    profit?: ILeaderProfit
}

// 백엔드가 받는 sort_by는 'copier' | 'mdd' | 'created_at' 뿐이다.
// 그 외 값은 전부 무시되고 copier DESC로 정렬되므로 이 세 개만 보낸다.
export type LeaderSortBy = 'copier' | 'mdd' | 'created_at'

export const getLeaderList = async (
    size: number,
    current_page: number = 1,
    keyword: string = '',
    exchange: string = '',
    sortBy: LeaderSortBy = 'created_at',
): Promise<ApiRes<ILeader[]>> => {
    return await apiGet(
        API_URL,
        `admin/copy/leaders?page_size=${size}&current_page=${current_page}&search=${keyword}&filter_exchange=${exchange}&sort_by=${sortBy}`,
    )
}

// 리스트/디테일 응답이 all_time_profit과 profit 두 형태를 함께 실어 보내므로 한 곳에서 흡수한다.
export const leaderAllTimeProfit = (leader?: {all_time_profit?: number; profit?: ILeaderProfit}): number =>
    leader?.profit?.all_time ?? leader?.all_time_profit ?? 0

export const leaderMonthlyProfit = (leader?: {profit?: ILeaderProfit}): number => leader?.profit?.monthly ?? 0
